<template>
    <!-- 荣誉 -->
    <div class="honor">
        <div class="content">
            <div class="title">我们的荣誉</div>
            <div class="honorBox">
                <div class="honorImgBox">
                    <div class="honorImgBoxTwo">
                        <img src="@/assets/image/common/honorPic1.png" alt="" class="honorImg" />
                    </div>
                </div>
                <div class="honorImgBox">
                    <div class="honorImgBoxTwo">
                        <img src="@/assets/image/common/honorPic2.png" alt="" class="honorImg" />
                    </div>
                </div>
                <div class="honorImgBoxBig">
                    <div class="honorImgBoxTwo">
                        <img src="@/assets/image/common/honorPic7.png" alt="" class="honorImg" />
                    </div>
                </div>
                <div class="honorImgBox">
                    <div class="honorImgBoxTwo">
                        <img src="@/assets/image/common/honorPic4.png" alt="" class="honorImg" />
                    </div>
                </div>
                <div class="honorImgBox">
                    <div class="honorImgBoxTwo">
                        <img src="@/assets/image/common/honorPic5.png" alt="" class="honorImg" />
                    </div>
                </div>
                <div class="honorImgBox">
                    <div class="honorImgBoxTwo">
                        <img src="@/assets/image/common/honorPic6.png" alt="" class="honorImg" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>

<style lang="scss" scoped>
.honor {
    width: 100%;
    height: 414px;
    display: flex;
    justify-content: center;
    padding-top: 50px;
    box-sizing: border-box;
    .content {
        width: 1200px;
        .title {
            width: 100%;
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 800;
            font-size: 34px;
            color: #1a1a1a;
            margin-bottom: 30px;
        }
        .honorBox {
            width: 1200px;
            display: flex;
            justify-content: space-between;
            .honorImgBox,
            .honorImgBoxBig {
                width: 180px;
                height: 210px;
                background: #ffffff;
                border-radius: 4px 4px 4px 4px;
                border: 1px solid #dddddd;
                cursor: pointer;
                overflow: hidden;
                padding: 6px;
                box-sizing: border-box;
                .honorImgBoxTwo {
                    width: 100%;
                    height: 100%;
                    overflow: hidden;
                }
                .honorImg {
                    width: 100%;
                    height: 100%;
                    transition: all 0.4s;
                }
                &:hover .honorImg {
                    transform: scale(1.1);
                }
            }
            .honorImgBoxBig {
                width: 266px;
            }
        }
    }
}
</style>
